// Device-local karaoke favourites — no login/server needed.
const KEY = "sk_kfavs";

export function getKFavs() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch (e) { return []; }
}

export function isKFav(videoId) {
  return getKFavs().some((x) => x.video_id === videoId);
}

export function toggleKFav(item) {
  const favs = getKFavs();
  const i = favs.findIndex((x) => x.video_id === item.video_id);
  if (i >= 0) favs.splice(i, 1);
  else favs.unshift({ video_id: item.video_id, title: item.title, channel: item.channel, thumbnail: item.thumbnail });
  localStorage.setItem(KEY, JSON.stringify(favs));
  window.dispatchEvent(new Event("sk-kfavs-changed"));
  return favs.some((x) => x.video_id === item.video_id);
}
